import { render, staticRenderFns } from "./AuthorizedRequestsReport.vue?vue&type=template&id=8a19d450&scoped=true"
import script from "./AuthorizedRequestsReport.vue?vue&type=script&lang=js"
export * from "./AuthorizedRequestsReport.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedRequestsReport.vue?vue&type=style&index=0&id=8a19d450&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a19d450",
  null
  
)

export default component.exports